<template>
  <v-card class="work-card" elevation="0">
    <v-card-title class="work-card-header">
      <div>
        <div class="work-card-title">Pending applications</div>
        <div class="work-card-subtitle">Applicants grouped by requested class</div>
      </div>
      <v-chip color="primary" text-color="white" small>{{ totalStudent }}</v-chip>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <div>
        <div ref="pieContainer" class="chart-container"></div>
      </div>
      <div v-if="!activeClasses.length" class="empty-state">
        <v-icon color="success" size="34">mdi-check-circle-outline</v-icon>
        <div>No pending applications</div>
      </div>
      <v-list v-else class="work-list">
        <template v-for="item in classesList">
          <v-list-item
            @click="openStudentList(item)"
            :key="item.name"
            v-if="item.totalStudentLeads !== 0"
          >
            <v-list-item-icon class="mr-3">
              <v-avatar color="#F1F8F2" size="36"><v-icon color="primary" size="19">mdi-account-school-outline</v-icon></v-avatar>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ genderSummary(item) }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip x-small outlined color="primary">{{ item.totalStudentLeads }}</v-chip>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    totalStudent: {
      type: Number,
      default: 0,
    },
    classesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    activeClasses() {
      return this.classesList.filter(item => Number(item.totalStudentLeads) > 0);
    },
  },
  // mounted() {
  //   this.renderPie();
  // },
  watch: {
    classesList: {
      handler() {
        // this.renderPie();
        this.renderDoc();
      },
      deep: true,
    },
  },
  methods: {
    renderPie() {
      const categories = this.classesList.map((row) => row.name);
      const values = this.classesList.map((row) => row.totalStudentLeads);

      // Prepare data in { name, y } format for Highcharts pie
      const pieData = categories.map((name, index) => ({
        name,
        y: values[index],
      }));

      Highcharts.chart(this.$refs.pieContainer, {
        credits: { enabled: false },
        chart: {
          type: "pie",
        },
        title: { text: null },
        tooltip: {
          pointFormat: "<b>{point.y} students</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.y}",
            },
            showInLegend: true,
          },
        },
        colors: [
          "#4BC0C0",
          "#36A2EB",
          "#FFCE56",
          "#8E5EA2",
          "#FF6384",
          "#36A200",
        ],
        series: [
          {
            name: "Applications",
            colorByPoint: true,
            data: pieData,
          },
        ],
      });
    },
    renderDoc() {
      const categories = this.activeClasses.map((row) => row.name);
      const values = this.activeClasses.map((row) => row.totalStudentLeads);

      const showDataLabels = !this.$vuetify.breakpoint.xsOnly;
      // Prepare data in { name, y } format for Highcharts pie
      const pieData = categories.map((name, index) => ({
        name,
        y: values[index],
      }));

      Highcharts.chart(this.$refs.pieContainer, {
        credits: { enabled: false },
        chart: {
          type: "pie",
          backgroundColor: "transparent",
          height: 230,
        },
        title: { text: null },
        tooltip: {
          pointFormat: "<b>{point.y} students</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            innerSize: "68%",
            dataLabels: {
              enabled: showDataLabels,
              format: "{point.name}: <b>{point.y}</b>",
              style: { color: "#64748B", fontSize: "11px", textOutline: "none" },
            },
            showInLegend: false,
          },
        },
        colors: [
          "#2E7D32", "#43A047", "#66BB6A", "#81C784", "#A5D6A7", "#C8E6C9",
        ],
        series: [
          {
            name: "Applications",
            colorByPoint: true,
            data: pieData,
          },
        ],
      });
    },
    genderSummary(item) {
      const parts = [];
      if (item.maleStudentLeads) parts.push(`${item.maleStudentLeads} male`);
      if (item.femaleStudentLeads) parts.push(`${item.femaleStudentLeads} female`);
      return parts.join(" · ") || "Applicant details";
    },
    openStudentList(item) {
      this.$router.push({
        path: "/applications/list",
        query: { ClassId: item.id, ClassName: item.name },
      });
    },
  },
};
</script>

<style scoped>
.work-card { height: 100%; border: 1px solid #e5eaf1; border-radius: 14px !important; overflow: hidden; }
.work-card-header { display: flex; justify-content: space-between; padding: 20px 22px; }
.work-card-title { color: #253047; font-size: 16px; font-weight: 700; }
.work-card-subtitle { color: #8491a5; font-size: 12px; font-weight: 400; margin-top: 3px; }
.chart-container { width: 100%; height: 230px; }
.work-list { max-height: 300px; overflow: auto; border-top: 1px solid #edf0f5; padding: 5px 10px; }
.work-list .v-list-item { border-radius: 9px; margin: 3px 0; }
.empty-state { height: 180px; display: flex; flex-direction: column; gap: 10px; align-items: center; justify-content: center; color: #64748b; }
</style>
